import { BACKGROUND_COLOR } from "../constants.js";

export const BACKGROUND = {
  "id": "background",
  "type": "background",
  "paint": { "background-color": BACKGROUND_COLOR },
};
